import React, { useState } from 'react';
import uploadFile from '../../utilities/uploadFile';
import LoadingSpinner from './LoadingSpinner';

function AddEmailForm() {
  const [isLoaded, setIsLoaded] = useState(true);
  const [uploadFiles, setUploadFiles] = useState(null);

  const myChangeHandler = (event) => {
    let nam = event.target.name;
    if (nam === 'files') {
      for (let i = 0; i < event.target.files.length; i++) {
        if (event.target.files[i].name.substr(-4) === '.msg') {
          setUploadFiles(event.target.files);
        } else {
          window.location.reload();
          alert(
            'Files(s) must be in .msg format. Choose a different file or folder.'
          );
        }
      }
    }
  };

  async function addEmailFiles(e) {
    e.preventDefault();
    setIsLoaded(false);
    for (let i = 0, numFiles = uploadFiles.length; i < numFiles; i++) {
      const file = uploadFiles[i];
      const s3Key = `/outreach/staging/${file.name}`;
      let r = await uploadFile(s3Key, file);
      console.log(r);
    }
    setIsLoaded(true);
    alert('Email file(s) successfully uploaded!');
    window.location.reload();
  }

  if (isLoaded) {
    return (
      <div className='container all-center'>
        <div
          className='card text-center'
          style={{ background: '#54c5f1', width: '385px' }}
        >
          <form id='addEmailFiles' onSubmit={addEmailFiles}>
            <label>
              Complete the 'Add Email Form' and hit <u>submit.</u>
            </label>
            <br />
            <i>
              * Hold CRTL/CMD to select multiple files. File(s) must be .msg
              format.
            </i>
            <input
              type='file'
              id='files'
              name='files'
              multiple
              onChange={myChangeHandler}
              style={{
                backgroundColor: 'white',
                width: '100%',
                marginBottom: '10px',
                resize: 'vertical'
              }}
            />
            <button
              className='btn btn-primary'
              type='submit'
              id='addEmailDocBtn'
              style={{ width: '60px', fontSize: 'x-small' }}
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    );
  } else if (!isLoaded) {
    return (
      <>
        <div>
          <h3 className='all-center'>Uploading files. Please wait...</h3>
          <LoadingSpinner />
        </div>
      </>
    );
  }
}

export default AddEmailForm;
